/**
 * Preloads the Text block component and its TipTap dependencies.
 * Call this early (e.g., in root layout) to ensure the heavy TipTap
 * chunk is loaded before it's needed for rendering.
 *
 * This is important because:
 * 1. Text blocks are common and often appear above the fold
 * 2. TipTap has many dependencies that create a large JS chunk
 * 3. Personalization (personalizeText) requires client-side rendering,
 *    so we can't pre-render the HTML during publishing
 */
export const preloadTextBlock = (): void => {
    import('$lib/components/Blocks/Text/Text.View.svelte');
};
